import type { Participant } from "@js/types/messenger";

type ActionBarProps = {
  participant: Participant;
};

export const ActionBar = (_props: ActionBarProps) => {
  return null;
};
